export { setPolyfills, clearCache, configureCache } from "./feature-repository";
export { GrowthBook } from "./GrowthBook";
//# sourceMappingURL=index.js.map